// components/ServiceCard.jsx
import { Link } from "react-router-dom";

export default function ServiceCard({ title, image, description, link, buttonLabel = "Learn More" }) {
  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-lg overflow-hidden transition duration-300">
      <img src={image} alt={title} className="w-full h-48 object-cover" loading="eager" fetchPriority="high" decoding="sync" />
      <div className="p-5">
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <p className="text-gray-600 mb-4">{description}</p>
        {link && (
          <Link
            to={link}
            className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-purple-700 transition"
          >
            {buttonLabel}
          </Link>
        )}
      </div>
    </div>
  );
}
